import { Col, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import * as clientReducer from "../../Redux/client/reducer";
import Feedback from "../../Utilities/Feedback";
import { LoadingOutlined } from "@ant-design/icons";
import { Formik } from "formik";
import { Form } from "formik-antd";
import {
  FormikDate,
  FormikSubmitButton,
  FormikTextArea,
} from "../../FormItems";
import FileUpload from "../../Utilities/FileUpload";
import moment from "moment";
import * as Yup from "yup";
import { Helmet } from "react-helmet";

const validationSchema = Yup.object({
  targetStartDate: Yup.date().required("Start Date is required").nullable(),
  targetEndDate: Yup.date().min(
    Yup.ref("targetStartDate"),
    "End Date should be greater than Start date"
  ),
});

const JobDetail = (props) => {
  const [showLastModified, setShowLastModified] = useState(false);
  const { fetchingJobs, jobDetail } = useSelector((state) => state.clientStore);
  const { getJobDetail, jobId, updateJobDetail } = props;
  // fetch the job details
  useEffect(() => {
    getJobDetail(jobId);
  }, [getJobDetail, jobId]);
  const {
    title,
    T24Release,
    additionalComments,
    attachments,
    createdDate,
    modifiedDate,
    targetEndDate,
    targetStartDate,
    typeRequirement,
    endDateFlexible,
  } = jobDetail;
  const [allFiles, setAllFiles] = useState([]);
  // show created date or modified date,
  useEffect(() => {
    if (createdDate === modifiedDate) {
      setShowLastModified(true);
    } else {
      setShowLastModified(false);
    }
  }, [createdDate, modifiedDate]);
  // set all the attachments in allFiles state varaible
  useEffect(() => {
    if (attachments) {
      setAllFiles([...attachments]);
    }
    return () => {
      setAllFiles([]);
    };
  }, [attachments]);
  const showDate = (date) => moment(date).format("YYYY/MM/DD");
  const initialValues = {
    targetStartDate: targetStartDate,
    targetEndDate: targetEndDate,
    endDateFlexible: endDateFlexible,
    additionalComments: additionalComments,
    fileIds: attachments ? attachments.map((eachFile) => eachFile.fileId) : [],
  };
  const getFileIds = (fileInfo) => {
    const files = [...allFiles];
    files.push(fileInfo);
    setAllFiles([...files]);
  };
  const dateFormat = (date) => moment(date).format("YYYY-MM-DD");
  const updateJob = (updatedJobDetails, actions) => {
    updatedJobDetails.fileIds = allFiles.map((eachFile) => eachFile.fileId);
    updatedJobDetails.targetStartDate = dateFormat(
      updatedJobDetails.targetStartDate
    );
    updatedJobDetails.targetEndDate = dateFormat(
      updatedJobDetails.targetEndDate
    );
    updateJobDetail(jobId, updatedJobDetails);
  };
  return (
    <Col style={{ overflowX: "hidden" }}>
      <Helmet title={`${title} | Unicon`} />
      {fetchingJobs ? (
        <Feedback icon={<LoadingOutlined />} title="Fetching the Job detail" />
      ) : (
        <Col
          xs={{ span: 22 }}
          md={{ span: 20 }}
          lg={{ span: 20 }}
          xl={{ span: 16 }}
          xxl={{ span: 16 }}
          style={{ margin: "auto", marginTop: "2vh" }}
        >
          <Formik
            validateOnMount
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={updateJob}
          >
            {(formik) => {
              console.log(formik);
              return (
                <Form>
                  <Col xs={{ span: 24 }}>
                    <Row justify="space-between">
                      <Col xs={{ span: 24 }} md={{ span: 12 }}>
                        <Typography.Title name="title" level={4}>
                          {title}
                        </Typography.Title>
                      </Col>
                    </Row>
                  </Col>
                  <Row name="typeRequirement">
                    <Typography.Paragraph>
                      Requirement Type :
                    </Typography.Paragraph>
                    <Typography.Text strong>{typeRequirement}</Typography.Text>
                  </Row>
                  <Row>
                    <Typography.Paragraph>T24 Version :</Typography.Paragraph>
                    <Typography.Text strong>{T24Release}</Typography.Text>
                  </Row>
                  <Row>
                    <Typography.Text>
                      {showLastModified ? (
                        <> Job Created On : {showDate(createdDate)}</>
                      ) : (
                        <>Last Modified : {showDate(modifiedDate)}</>
                      )}
                    </Typography.Text>
                  </Row>
                  <Row style={{ marginTop: "2vh" }} justify="space-between">
                    <Col xs={{ span: 24 }} md={{ span: 10 }} xl={{ span: 11 }}>
                      <FormikDate
                        name="targetStartDate"
                        id="targetStartDate"
                        label="Start Date"
                        value={targetStartDate}
                      ></FormikDate>
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 10 }} xl={{ span: 11 }}>
                      <FormikDate
                        name="targetEndDate"
                        id="targetEndDate"
                        label="End Date"
                        value={targetEndDate}
                      ></FormikDate>
                    </Col>
                  </Row>
                  <Row justify="space-between" style={{ marginTop: "2vh" }}>
                    <Col
                      xs={{ span: 24 }}
                      md={{ span: 10 }}
                      lg={{ span: 10 }}
                      xl={{ span: 11 }}
                    >
                      <FormikTextArea
                        id="additionalComments"
                        label="Additional Comments"
                        name="additionalComments"
                        value={additionalComments}
                      />
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 12 }} xl={{ span: 11 }}>
                      <FileUpload
                        id="fileUpload"
                        name="fileIds"
                        getIds={true}
                        getFileIds={getFileIds}
                        uploadedFiles={allFiles ? allFiles : []}
                      ></FileUpload>
                    </Col>
                  </Row>
                  <Col xs={{ span: 24 }} md={{ span: 6 }}>
                    <FormikSubmitButton
                      id="submit-saveAndUpdate"
                      disabled={!formik.isValid}
                      name="Update"
                    />
                  </Col>
                </Form>
              );
            }}
          </Formik>
        </Col>
      )}
    </Col>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getJobDetail: (jobId) => dispatch(clientReducer.getJobDetail(jobId)),
    updateJobDetail: (jobId, jobDetails) =>
      dispatch(clientReducer.updateJobDetail(jobId, jobDetails)),
  };
};

export default connect(null, mapDispatchToProps)(JobDetail);
